import React from 'react';
import UserProfile from './profile/UserProfile';

function Dashboard({ userData, apiError, showUsernameForm, onUsernameSet, onAvatarUpdate }) {
  return (
    <div className="Dashboard">
      <UserProfile
        userData={userData}
        apiError={apiError}
        showUsernameForm={showUsernameForm}
        onUsernameSet={onUsernameSet}
        onAvatarUpdate={onAvatarUpdate}
      />
      {/* Add other dashboard content */}
    </div>
  );
}

export default Dashboard;